export const pageIdInfos = Object.freeze({
  // v10.9.0 ~ (구) 마이
  main: {
    pageId: 'main',
    url: '/web',
    name: 'MY 메인',
  },
  // v11.0.0 ~ (신규) 마이, 오픈프로필
  my_service: {
    pageId: 'my_service',
    url: '/web/my',
    name: 'My 서비스 메인',
  },
  open_profile: {
    pageId: 'open_profile',
    url: '/web/my',
    name: '오픈 프로필 서비스 메인',
  },
  profile: {
    pageId: 'profile',
    url: '/web/profile',
    name: '프로필(새 웹뷰)',
  },
  profile_report: {
    pageId: 'profile_report',
    url: '/web/profile/report',
    name: '프로필 신고',
  },
  // SNS
  sns_manage: {
    pageId: 'sns_manage',
    url: '/web/my/sns',
    name: 'SNS 링크 관리 페이지',
  },
  sns_register: {
    pageId: 'sns_register',
    url: '/web/my/sns/register',
    name: 'SNS 링크 등록 페이지',
  },
  sns_edit: {
    pageId: 'sns_edit',
    url: '/web/my/sns/edit/:type',
    name: 'SNS 링크 수정 페이지',
  },
  // 전체서비스
  all_services: {
    pageId: 'all_services',
    url: '/web/all_services',
    name: '전체 서비스',
  },
  // 만보기
  step_counter: {
    pageId: 'step_counter',
    url: '/web/step_counter',
    name: '만보기 서비스',
  },
  step_counter_terms_withdrawal: {
    pageId: 'step_counter_terms_withdrawal',
    url: '/web/step_counter/withdrawal',
    name: '만보기 서비스 탈퇴',
  },
  move_log: {
    pageId: 'move_log',
    url: '/web/move_log',
    name: '이동 로그 홈',
  },
  move_log_insight: {
    pageId: 'move_log_insight',
    url: '/web/move_log/insight',
    name: '이동 로그 인사이트',
  },
  vertical_poi_search: {
    pageId: 'vertical_poi_search',
    url:'/web/vertical/poi-search',
    name: '버티컬 장소 검색'
  },
  vertical_poi_category: {
    pageId: 'vertical_poi_category',
    url:'/web/vertical/poi-category',
    name: '버티컬 장소 검색'
  }
} as const)
